import { create } from 'zustand';

import type { IUIState } from './types';

export const useUIStore = create<IUIState>((set) => {
  return {
    showMobileSidebar: true,
    setShowMobileSidebar: (open) => {
      return set({ showMobileSidebar: open });
    },
  };
});
